import React, { useState } from 'react'
import { Drawer, Upload, Menu } from 'antd'
import Select from 'react-select'
import { useSelector } from 'react-redux'
import { AiOutlineInbox } from 'react-icons/ai'
import { useSnackbar } from 'notistack'

import { usePet, notifOps } from '../../modules'
import Confirm from '../reusable/confirm'

const { Dragger } = Upload

const NewHostedDocument = ({ toggle, visible, onPerform }) => {
    const [name, setName] = useState()
    const [allowedRoles, setAllowed] = useState([])
    const [roles, setRoles] = useState([])
    const [document, setDocument] = useState([])

    const { enqueueSnackbar } = useSnackbar()

    const { params } = useSelector(state => state.application)

    const close = () => {
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Document has been added', ops('success'))
        
        setTimeout(close, 300)
    }

    usePet('roles', { limit: 100 }, { notify: true, callback: async ({ data }) => { 
        setRoles(data?.roles?.map(store => ({
            label: store.name,
            value: store._id
        })))
    } })

    const [{ loading }, execute] = usePet('newHostedDocument', {
        name,
        roles: allowedRoles?.map(role => role.value),
        document: document[0]?.originFileObj
    }, { notify: true, hasFile: true, callback: onComplete, manual: true })

    const props = {
        name: 'referral',
        fileList: document,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange: info => {
            let { fileList } = info
            fileList = fileList.slice(-1)

            let isNotPDF = fileList[0]?.type !== 'application/pdf'
            if (isNotPDF)
                enqueueSnackbar('Please upload a pdf file', notifOps('warning'))
    
            let isLarge = (fileList[0]?.size / 1024 / 1024) > params?.maxFileUploadSize
            if (isLarge)
                enqueueSnackbar(`Please upload a file smaller than ${params?.maxFileUploadSize} MB`, notifOps('warning'))
            
            if (!(isNotPDF || isLarge))
                setDocument(fileList)
        },
        beforeUpload: () => false,
        onDrop: (e) => {
            console.log('Dropped files', e.dataTransfer.files);
        },
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={ () => Confirm({
                        title: 'Upload Document?',
                        message: 'Please confirm before uploading this document?',
                        onOk: execute,
                        okText: 'Upload Document',
                    })} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Upload Document</button>
                </div>
            }
            width={600}>
            <p className="font-extrabold text-3xl mb-0">New Hosted Document</p>
            <div className="divide-y divide-light-gray-400">
                <div className="flex flex-wrap mt-3 -mx-3">
                    <div className="w-full md:w-2/3 px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Document Name
                        </label>
                        <input 
                            onChange={ e => setName(e.target.value) }
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                            id="grid-doc-name" 
                            type="text" 
                            value={ name }
                            name="name"
                            placeholder="Discharge Summary" />
                    </div>
                </div>
                <div>
                    <p className="font-bold my-3">Allowed Roles</p>
                    <Select
                        isMulti 
                        value={ allowedRoles }
                        onChange={ setAllowed }
                        options={ roles }
                        placeholder="Select Roles" />
                </div>
                <div>
                    <p className="font-bold my-3">Upload Document</p>
                    <Dragger {...props}>
                        <p className="ant-upload-drag-icon flex justify-center">
                            <AiOutlineInbox size={40} />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">Please select a pdf file</p>
                    </Dragger>
                </div>
            </div>
        </Drawer>
    )
}

export default NewHostedDocument